import { render, staticRenderFns } from "./DetailCandidatureSuaio.vue?vue&type=template&id=84a267a2"
import script from "./DetailCandidatureSuaio.vue?vue&type=script&lang=js"
export * from "./DetailCandidatureSuaio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports